import React, { useCallback, useEffect, useRef, useState } from "react";
import { getVideoMediaTokenActionHandler } from "../../../../store/actions/actionHandlers/manageActionHandler";
import { useDispatch } from "react-redux";
import "./VideoContent.scss";
import VideoPlayer from "../../../Common/videoPlayer/VideoPlayer";
import Loader from "../../../Common/Loader/Loader";

const VideoContent = ({ shotclassData, autoplay = true }) => {
  // let amp = window["amp"];

  // const videoElement = useRef();
  const dispatch = useDispatch();
  const [mediaToken, setMediaToken] = useState("");
  const [loader, setLoader] = useState(true);

  // const createVideoPlayer = useCallback();
  // (amp) => {
  //   let video = amp(videoElement.current, {
  //     nativeControlsForTouch: true,
  //     autoplay: autoplay,
  //     controls: true,
  //     width: "100%",
  //     logo: { enabled: false },
  //     techOrder: ["azureHtml5JS", "html5FairPlayHLS", "html5"],
  //   });
  //   return video;
  // },
  // [autoplay]

  useEffect(() => {
    if (shotclassData?.AssetId) {
      dispatch(getVideoMediaTokenActionHandler(shotclassData.AssetId)).then(
        (mediaTokenId) => {
          // const videoPlayer = createVideoPlayer(amp);
          if (mediaTokenId !== undefined && shotclassData.VideoUrl !== "") {
            setLoader(false);
            setMediaToken(mediaTokenId);
            // if (shotclassData.IsVideoEncrypted === true) {
            //   let isSafari =
            //     /constructor/i.test(window.HTMLElement) ||
            //     (function (p) {
            //       return p.toString() === "[object SafariRemoteNotification]";
            //     })(!window["safari"]);
            //   let iOS =
            //     /iPad|iPhone|iPod/.test(navigator.userAgent) &&
            //     !window.MSStream;

            //   if (isSafari || iOS) {
            //     // alert("inside ios and safari");
            //     var proxy =
            //       "http://iosproxy.azurewebsites.net/home/Manifest?playbackUrl=";
            //     var subToken = encodeURIComponent(
            //       mediaTokenId?.Content.substring(
            //         7,
            //         mediaTokenId?.Content.length
            //       )
            //     );
            //     videoPlayer.src([
            //       {
            //         src:
            //           proxy +
            //           shotclassData.VideoUrl +
            //           "(format=m3u8-aapl)&webtoken=" +
            //           subToken,
            //         type: "application/vnd.apple.mpegurl",
            //         protectionInfo: [
            //           {
            //             type: "AES",
            //             authenticationToken: mediaTokenId?.Content,
            //           },
            //         ],
            //       },
            //     ]);
            //   } else {
            //     // alert("inside else of ios and safari")
            //     videoPlayer.src([
            //       {
            //         src: shotclassData.VideoUrl,
            //         type: "application/vnd.ms-sstr+xml",
            //         protectionInfo: [
            //           {
            //             type: "AES",
            //             authenticationToken: mediaTokenId?.Content,
            //           },
            //         ],
            //       },
            //     ]);
            //   }
            // } else {
            //   videoPlayer.src([
            //     {
            //       src: shotclassData.VideoUrl,
            //       type: "application/vnd.ms-sstr+xml",
            //     },
            //   ]);
            // }
          }
        }
      );
    }
    // else if (shotclassData?.VideoUrl) {
    // const videoPlayer = createVideoPlayer(amp);
    // videoPlayer.src([
    //   {
    //     src: shotclassData?.VideoUrl,
    //     type: shotclassData?.type,
    //   },
    // ]);
    // }
  }, [shotclassData?.AssetId]);

  return (
    <div className="videoContent">
      {loader && !shotclassData?.type ? (
        <div className="loader">
          <Loader />
        </div>
      ) : (
        <VideoPlayer
          mediaKindToken={mediaToken}
          setMediaKindToken={setMediaToken}
          videoUrl={shotclassData.VideoUrl}
          isPlayedFromLocal={shotclassData?.type ? true : false}
          type={shotclassData?.type}
        />
      )}
    </div>
  );
};

export default VideoContent;
